import { report } from './mdap';

export function measureTime(id: string) {
  return function(target: any, key: any, descriptor: PropertyDescriptor) {
    const origin = descriptor.value;
    descriptor.value = async function (...args: any[]) {
      let t = 0;
      if (typeof window !== 'undefined' && typeof performance !== 'undefined') {
        t = performance.now();
      }
      const res = await origin.apply(this, args);
      if (typeof window !== 'undefined' && typeof performance !== 'undefined') {
        report(id, performance.now() - t);
      }
      return res;
    };
  }
}
